module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_square_hazel.0fb080d6.png";